var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDrift = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#070707",
    fillRule: "evenodd",
    d: "M20.52 3.51C13.105 3.24 6.764 8.753 6.063 16.08c-.7 7.327 4.481 13.925 11.815 15.043a.33.33 0 0 1 .25.466l-2.085 4.26-.09.187a.334.334 0 0 0 .226.452.34.34 0 0 0 .188-.004C20.721 35.15 34 28.294 34 17.214c.006-7.35-6.079-13.44-13.48-13.704",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.55 10.5q.092 0 .184.014c.233.05.336.25.215.42a2 2 0 0 1-.084.094l-3.973 4.24s-.074.074-.103.114c-.146.19 0 .421.28.437h1.623c.267.025.404.255.263.44a2 2 0 0 1-.11.122l-2.93 3.1q-.055.054-.1.114c-.128.187.02.405.286.42h1.058a.37.37 0 0 1 .342.18.244.244 0 0 1-.084.314l-.084.067-6.773 4.796q-.06.052-.126.098a.21.21 0 0 1-.214 0 .124.124 0 0 1-.064-.159c.015-.04.058-.119.058-.119l1.867-3.611.054-.107c.125-.236 0-.436-.278-.473H15.45q-.08 0-.158-.008c-.23-.034-.352-.215-.265-.393.02-.04.07-.116.07-.116l2.317-3.647s.026-.04.038-.063c.127-.215-.026-.42-.318-.43h-1.52c-.197 0-.337-.097-.367-.245a.3.3 0 0 1 .061-.213l3.02-4.998.057-.09c.118-.201.318-.299.587-.299h6.577Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDrift);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drift.0267db76.svg";